import { Suspense } from 'react';
import { createFileRoute, notFound } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { InstitutePapersPage } from '@/features/question/pages/InstitutePapersPage';
import { institutePapersSearchSchema } from '@/features/question/types/question.types';
import { parsePositiveIdParams } from '@/utils/routeParams';

export const Route = createFileRoute('/_auth/question/papers/$projectInstituteId')({
  parseParams: (rawParams) => {
    const params = parsePositiveIdParams(rawParams);
    if (params === null) throw notFound();
    return params;
  },
  validateSearch: institutePapersSearchSchema,
  component: function InstitutePapersRoute() {
    const { projectInstituteId } = Route.useParams();
    const search = Route.useSearch();
    return (
      <ErrorBoundary moduleName="Institute Papers">
        <Suspense fallback={<PageLoader />}>
          <InstitutePapersPage projectInstituteId={projectInstituteId} search={search} />
        </Suspense>
      </ErrorBoundary>
    );
  },
});
